import { get } from 'lodash-es'

 const getEnvironmentVariable = name =>
   get(window.env, name) || get(process.env, name)

 export default getEnvironmentVariable
